import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
export { default } from '@/views/bag'

export async function getServerSideProps ({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'ext'])),
      meta: {
        authRequired: true,
        trackingInfo: {
          screenName: 'live_product'
        }
      }
    }
  }
}
